// extracted by mini-css-extract-plugin
export default {"paymentSection":"I8-z","disabled":"J8-z"};